'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _dropdown = require('dropdown');

var _insurersHint = require('./insurers-hint');

var _insurersHint2 = _interopRequireDefault(_insurersHint);

var _doctifyUtils = require('doctify-utils');

var _specialtySvgIcon = require('../../../specialty-svg-icon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchBarAligner = function searchBarAligner(scrollOffset) {
	try {
		var Doc = document.documentElement;
		var duration = 800;
		var start = Doc.scrollTop;
		var currentTime = 0;
		var increment = 20;

		var change = scrollOffset - start;

		var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
			t /= d / 2;
			if (t < 1) return c / 2 * t * t + b;
			t--;
			return -c / 2 * (t * (t - 2) - 1) + b;
		};

		var animateScroll = function animateScroll() {
			currentTime += increment;
			document.documentElement.scrollTop = easeInOutQuad(currentTime, start, change, duration);
			if (currentTime < duration) {
				setTimeout(animateScroll, increment);
			}
		};
		animateScroll();
	} catch (e) {
		console.log('unsupported browser dkb-140');
	}
};

var SearchBar = function SearchBar(props) {
	var isMobile = props.isMobile,
	    showInsurer = props.showInsurer,
	    showLocation = props.showLocation,
	    doSearch = props.doSearch,
	    searchType = props.searchType,
	    getLocationNearMe = props.getLocationNearMe,
	    clearLocationNearMe = props.clearLocationNearMe,
	    usingNearMe = props.usingNearMe,
	    findingLocation = props.findingLocation,
	    pageName = props.pageName,
	    autocompleteSearchItems = props.autocompleteSearchItems,
	    autocompleteLocationItems = props.autocompleteLocationItems,
	    insurers = props.insurers,
	    onSearchTextChanged = props.onSearchTextChanged,
	    onLocationTextChanged = props.onLocationTextChanged,
	    onInsurerSelected = props.onInsurerSelected,
	    onKeywordSelected = props.onKeywordSelected,
	    onLocationSelected = props.onLocationSelected,
	    intl = props.intl,
	    scrollOffset = props.scrollOffset;


	var searchButtonLabel = pageName === 'home' ? intl.formatMessage(_defaultMessages2.default.SEARCH) : intl.formatMessage(_defaultMessages2.default.UPDATE);
	var onSearchClicked = function onSearchClicked() {
		doSearch({
			keyword: props.selectedSearchTerm,
			location: props.selectedLocation,
			insurer: props.selectedInsurer
		});
	};

	return !isMobile ? _react2.default.createElement(
		'div',
		{ className: '' + _style.searchBarContainer },
		_react2.default.createElement(
			'div',
			{ className: _style.searchBarHolder },
			showInsurer && _react2.default.createElement(
				'div',
				{ className: _style.searchInsurerHolder + ' ' + _style.dropdownHolder + ' ' + _style.dfInputGroup },
				_react2.default.createElement(_dropdown.Dropdown, {
					id: 'InsurerDropdown',
					className: _style.autocompleteInsurer + ' ' + _style2.default['dropdown-elem'],
					tabIndex: 1,
					placeholder: intl.formatMessage(_defaultMessages2.default.HOSPITAL_LIST_PLACEHOLDER),
					onItemSelected: onInsurerSelected,
					selectedItem: props.selectedInsurer,
					readonly: true,
					items: insurers,
					ref: function ref(elem) {
						if (elem && (!props.page.insurersDropdownElem || props.page.insurersDropdownElem !== elem)) {
							props.pageActions.updateInsurersDropdownElem(elem);
						}
					},
					ContentRenderer: function ContentRenderer() {
						return _react2.default.createElement(
							'div',
							{ className: '' + _style.dropdownContentRenderer },
							_react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
							_react2.default.createElement('i', { className: 'ion-android-arrow-dropdown' })
						);
					},
					ItemRenderer: function ItemRenderer(rendererProps) {
						var item = rendererProps.item,
						    nameTransform = rendererProps.nameTransform;

						return _react2.default.createElement(
							'div',
							{ className: _style.dropdownItemRenderer + ' ' + _style.insurerDropdownItemRenderer },
							_react2.default.createElement(
								'span',
								null,
								nameTransform(item)
							)
						);
					},
					onOpenDropDown: function onOpenDropDown() {
						props.scrollOnOpenDropDown && searchBarAligner(scrollOffset);
					},
					hint: _react2.default.createElement(_insurersHint2.default, null)
				})
			),
			_react2.default.createElement(
				'div',
				{ className: _style.searchAutocompleteHolder + ' ' + _style.dropdownHolder + ' ' + _style.dfInputGroup + ' ' + (searchType === 'practice' ? _style.practice : '') },
				_react2.default.createElement(_dropdown.Dropdown, {
					id: 'AutocompleteSearch',
					className: _style.autocompleteSearch,
					tabIndex: 2,
					placeholder: props.autocompleteSearchPlaceHolder || intl.formatMessage(_defaultMessages2.default.SEARCH_PLACEHOLDER),
					onTextChanged: onSearchTextChanged,
					onItemSelected: onKeywordSelected,
					selectedItem: props.selectedSearchTerm,
					items: autocompleteSearchItems,
					ref: function ref(elem) {
						if (elem && (!props.page.searchItemDropdownElem || props.page.searchItemDropdownElem !== elem)) {
							props.pageActions.updateSearchItemDropdownElem(elem);
						}
					},
					ContentRenderer: function ContentRenderer() {
						return _react2.default.createElement(
							'div',
							{ className: '' + _style.dropdownContentRenderer },
							_react2.default.createElement('i', { className: (searchType === 'practice' ? 'ion-ios-heart-outline' : 'ion-ios-pulse') + ' ' + (searchType === 'practice' ? _style.blue : '') }),
							_react2.default.createElement('i', { className: 'ion-android-arrow-dropdown' })
						);
					},
					itemDisplayNameTransform: function itemDisplayNameTransform(item) {
						return item.name;
					},
					itemChildrenTransform: function itemChildrenTransform(item) {
						return item.children;
					},
					ItemRenderer: function ItemRenderer(rendererProps) {
						var item = rendererProps.item,
						    nameTransform = rendererProps.nameTransform,
						    childrenTransform = rendererProps.childrenTransform;


						if (item.renderAsProfile === true) {
							var profileImage = item.profile_image;
							var profileTopSpecialty = item.related_specialties && item.related_specialties.filter(function (specialty) {
								return specialty.parent_name === "abstract_top_level_keyword";
							})[0];
							profileTopSpecialty = profileTopSpecialty && props.listings.specialties.find(function (item) {
								return item.id === profileTopSpecialty.id;
							});

							return _react2.default.createElement(
								'div',
								{ className: _style.dropdownItemRenderer + ' ' + _style.profileDropdownItemRenderer },
								profileImage && _react2.default.createElement('img', { src: profileImage, alt: nameTransform(item) }) || profileTopSpecialty && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, { specialtyIconUri: profileTopSpecialty.icon_uri, className: _style.specialtyIcon }),
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'span',
										{ className: _style.profileName },
										'' + nameTransform(item) + (item.networks && item.networks.length && '.' || '')
									),
									profileTopSpecialty && _react2.default.createElement(
										'span',
										{ className: _style.profileSpecialty },
										profileTopSpecialty.name
									)
								),
								_react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-right' : '') + ' ' + _style.parentIconDesktop + ' ' + (searchType === 'practice' ? _style.blue : '') }),
								_react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-down' : '') + ' ' + _style.parentIconMobile + ' ' + (searchType === 'practice' ? _style.blue : '') })
							);
						} else {
							return _react2.default.createElement(
								'div',
								{ className: '' + _style.dropdownItemRenderer },
								item.icon_uri && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, { specialtyIconUri: item.icon_uri, className: _style.specialtyIcon }) || null,
								_react2.default.createElement(
									'span',
									null,
									nameTransform(item)
								),
								_react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-right' : '') + ' ' + _style.parentIconDesktop + ' ' + (searchType === 'practice' ? _style.blue : '') }),
								_react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-down' : '') + ' ' + _style.parentIconMobile + ' ' + (searchType === 'practice' ? _style.blue : '') })
							);
						}
					},
					onOpenDropDown: function onOpenDropDown() {
						props.scrollOnOpenDropDown && searchBarAligner(scrollOffset);
					},
					showExpandedDropdown: props.showExpandedDropdown
				})
			),
			showLocation && _react2.default.createElement(
				'div',
				{ className: _style.searchLocationHolder + ' ' + _style.dropdownHolder + ' ' + _style.dfInputGroup + ' ' + (searchType === 'practice' ? _style.practice : '') },
				_react2.default.createElement(_dropdown.Dropdown, {
					id: 'location-autocomplete',
					className: _style.autocompleteLocation,
					tabIndex: 3,
					placeholder: props.locationPlaceholder || intl.formatMessage(_defaultMessages2.default.LOCATION_PLACEHOLDER),
					selectedItem: props.selectedLocation,
					onTextChanged: onLocationTextChanged,
					onItemSelected: onLocationSelected,
					onReceiveFocus: clearLocationNearMe,
					items: autocompleteLocationItems,

					setInputField: props.setLocationInputField,
					inputField: props.locationInputField,

					ContentRenderer: function ContentRenderer() {
						return _react2.default.createElement(
							'div',
							{ className: '' + _style.dropdownContentRenderer },
							_react2.default.createElement('i', { className: 'ion-ios-location-outline ' + (searchType === 'practice' ? _style.blue : '') }),
							_react2.default.createElement('div', { className: (usingNearMe ? _style.nearMeBackground : '') + ' ' + (findingLocation ? _style.pulse : '') + ' ' + (searchType === 'practice' ? _style.backgroundBlue : '') }),
							_react2.default.createElement('i', { className: 'ion-pinpoint ' + (searchType === 'practice' ? _style.blue : '') + ' ' + (usingNearMe ? _style.white : '') + ' ' + (findingLocation ? _style.pulse : ''), onClick: function onClick(event) {
									if (usingNearMe) {
										clearLocationNearMe();
									} else {
										getLocationNearMe();
									}
									event.stopPropagation();
								} })
						);
					},
					ItemRenderer: function ItemRenderer(rendererProps) {
						var item = rendererProps.item,
						    nameTransform = rendererProps.nameTransform;

						return _react2.default.createElement(
							'div',
							{ className: _style.dropdownItemRenderer + ' ' + _style.locationDropdownItemRenderer },
							_react2.default.createElement(
								'span',
								null,
								nameTransform(item)
							)
						);
					},
					onOpenDropDown: function onOpenDropDown() {
						props.scrollOnOpenDropDown && searchBarAligner(scrollOffset);
					}
				})
			),
			_react2.default.createElement(
				'div',
				{ className: _style.searchButtonHolder },
				_react2.default.createElement(
					'button',
					{ onClick: onSearchClicked,
						className: _style.btn + ' ' + _style.searchButton + ' ' + _style.solid + ' ' + (searchType === 'practice' ? _style.practice : '') },
					_react2.default.createElement(
						'span',
						null,
						searchButtonLabel
					)
				)
			)
		)
	) : null;
};

SearchBar.propTypes = {
	isMobile: require('react').PropTypes.bool.isRequired,
	showInsurer: require('react').PropTypes.bool.isRequired,
	showLocation: require('react').PropTypes.bool.isRequired,
	scrollOnOpenDropDown: require('react').PropTypes.bool.isRequired,
	searchType: require('react').PropTypes.string,
	selectedSearchTerm: require('react').PropTypes.any,
	selectedLocation: require('react').PropTypes.any,
	selectedInsurer: require('react').PropTypes.any,
	getLocationNearMe: require('react').PropTypes.func.isRequired,
	clearLocationNearMe: require('react').PropTypes.func.isRequired,
	usingNearMe: require('react').PropTypes.bool,
	findingLocation: require('react').PropTypes.bool,
	doSearch: require('react').PropTypes.func.isRequired,
	pageName: require('react').PropTypes.string,
	autocompleteSearchPlaceHolder: require('react').PropTypes.string,
	autocompleteSearchDropdownOpen: require('react').PropTypes.bool,
	autocompleteSearchItems: require('react').PropTypes.arrayOf(require('react').PropTypes.any),
	autocompleteLocationItems: require('react').PropTypes.arrayOf(require('react').PropTypes.any),
	autocompleteLocationDropdownOpen: require('react').PropTypes.bool,
	insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.any),
	insurerDropdownOpen: require('react').PropTypes.bool,
	onSearchTextChanged: require('react').PropTypes.func.isRequired,
	onLocationTextChanged: require('react').PropTypes.func.isRequired,
	onLocationSelected: require('react').PropTypes.func,
	onKeywordSelected: require('react').PropTypes.func,
	onInsurerSelected: require('react').PropTypes.func,
	intl: require('react').PropTypes.object.isRequired,
	setLocationInputField: require('react').PropTypes.func.isRequired,
	locationInputField: require('react').PropTypes.any.isRequired
};
SearchBar.displayName = 'SearchBar';

SearchBar.defaultProps = {
	isMobile: false,
	showInsurer: true,
	showLocation: true,
	searchType: 'specialist',
	scrollOnOpenDropDown: true,
	doSearch: function doSearch() {},
	autocompleteSearchPlaceHolder: 'Type in a speciality, condition, procedure, name...',
	autocompleteSearchItems: [],
	autocompleteLocationItems: [],
	insurers: [],
	onSearchTextChanged: function onSearchTextChanged() {},
	onLocationTextChanged: function onLocationTextChanged() {}
};

exports.default = (0, _reactIntl.injectIntl)(SearchBar);


// WEBPACK FOOTER //
// ./components/search-bar/lib/components/search-bar.js